import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import i18n from 'i18next';
import { Icon, Button } from 'Components';
import './EditJob.css';

const EditJob = ({ onClick }) => (
  <Button onClick={onClick} className="actions__edit-job">
    <div
      className={classNames('actions__edit-job__text', {
        'actions__edit-job__text--center': i18n.language === 'F',
      })}
    >
      <div>{i18n.t('editJob:EditJob')}</div>
      <div>{i18n.t('editJob:information')}</div>
    </div>
    <Icon icon="edit" />
  </Button>
);

EditJob.propTypes = {
  onClick: PropTypes.func,
};
export default EditJob;



// WEBPACK FOOTER //
// ./src/components/Actions/EditJob/EditJob.jsx